import { Article } from '../models/kb-articles.model';
import { NavList } from '../models/navlist.model'
import { Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Widget } from '../models/widget.model';
import { AuthService } from './auth.service';
import * as moment from 'moment';
import { GlobalConstants } from '../global-constants';
import { Notifications } from '../models/notification';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(private http: HttpClient, private router: Router, private authService: AuthService) { }

  private navList: NavList[] = [];
  private navListUpdated = new Subject<NavList[]>();
  private widgetUpdated = new Subject<Widget[]>();
  private notificationUpdated = new Subject<Notifications[]>();
  publisherName: string;
  localArticle = new Map<string, Article>([]);
  baseUrl: string = environment.baseUrl;
  clientId: string = environment.clientId;
  urlToNavigate: string;
  UserId: any;
  Moderator = GlobalConstants.Moderator;
  Publisher = GlobalConstants.Publisher;
  dloUser = GlobalConstants.dloUser;
  Deleted = GlobalConstants.Deleted;
  AttchStatusCreate = GlobalConstants.AttchStatusCreate;
  AttchStatusDelete = GlobalConstants.AttchStatusDelete;
  AttchStatusUpdate = GlobalConstants.AttchStatusUpdate;
  addNavItem(folderName: string, parentId: number, folderType: string, url: string) {
    //SUBSCRIBE TO CHANGE
    this.authService.itemValue.subscribe((nextValue) => {
      this.UserId = nextValue.UserId;
    })

    if (!this.UserId || typeof this.UserId === 'undefined' || this.UserId === "undefined")
      this.UserId = null;
    else
      this.UserId = parseInt(this.UserId);

    let body = {
      folderName: folderName,
      parentId: parentId,
      userId: this.UserId,
      folderType: folderType
    };
    this.http.post<{ Error: string, data: any, Status: string, Message: string }>
      (this.baseUrl + '/Folder/Save', body)
      .subscribe((result) => {
        if (result.Error.toLowerCase().includes("invalid request payload")) {
          this.setNotification("Folder/File name already exists! Please choose a different name!", "Error");
          this.router.navigateByUrl('/home');
          return;
        }
        else if (result.Status == "Failure") {
          this.setNotification("Something went wrong! Please try again after some time.", "Error");
          this.router.navigateByUrl('/home');
          return;
        }
        else
          this.getNavList();
        if (folderType == 'File')
          this.urlToNavigate = url + '/article/create'
        else
          this.urlToNavigate = '/';
        this.setNotification("Folder/File created Successfully!", "Success")
        this.router.navigateByUrl(this.urlToNavigate)
      });
  }
  updateNavItem(id: number, folderName: string) {
    this.authService.itemValue.subscribe((nextValue) => {
      this.UserId = nextValue.UserId;

    })
    if (!this.UserId || typeof this.UserId === 'undefined' || this.UserId === "undefined")
      this.UserId = null;
    else
      this.UserId = parseInt(this.UserId);

    let body = {
      id: id,
      folderName: folderName,
      userId: this.UserId
    };
    this.http.post<{ Error: string, data: any, Status: string, Message: string }>
      (this.baseUrl + '/Folder/Save', body)
      .subscribe((data) => {
        if (data.Error.toLowerCase().includes("invalid request payload")) {
          this.setNotification("Folder/File name already exists! Please choose a different name!", "Error")
        }
        else if (data.Status == "Failure") {
          this.setNotification("Something went wrong! Please try again after some time.", "Error");
          this.router.navigateByUrl('/home');
          return;
        }
        else {
          this.setNotification("Folder/File name updated Successfully!", "Success")
          this.getNavList();
        }
        this.router.navigate(['/'])
      });
  }
//for restoring

updateNavItemForRestoring(id: number, folderName: string) {
  this.authService.itemValue.subscribe((nextValue) => {
    this.UserId = nextValue.UserId;

  })
  if (!this.UserId || typeof this.UserId === 'undefined' || this.UserId === "undefined")
    this.UserId = null;
  else
    this.UserId = parseInt(this.UserId);

  let body = {
    id: id,
    folderName: folderName,
    userId: this.UserId
  };
  this.http.post<{ Error: string, data: any, Status: string, Message: string }>
    (this.baseUrl + '/Folder/Save', body)
    .subscribe((data) => {
    // if(data.Status == "Success")
     this.getNavList();
    });
}
updateArticleItemForRestoring(data:Array<any>) {

  this.authService.itemValue.subscribe((nextValue) => {
    this.UserId = nextValue.UserId;

  })
  if (!this.UserId || typeof this.UserId === 'undefined' || this.UserId === "undefined")
    this.UserId = null;
  else
    this.UserId = parseInt(this.UserId);

  this.http.post<{ Error: string, data: any, Status: string, Message: string }>
    (this.baseUrl + '/Article/ReinitiateFolder', data )
    .subscribe((data1) => {
      this.setNotification("Folder Restored Successfully!", "Success");
      for(let i=0;i<data.length;i++){
        this.modifyLocalStatus(data[i]["ArticleId"],"Drafted");

      }

      this.getNavList();
   });
   this.router.navigate(['/']);
}

checkFolderNameExists(folderId, folderName) {
  this.authService.itemValue.subscribe((nextValue) => {
    this.UserId = nextValue.UserId;

  })
  if (!this.UserId || typeof this.UserId === 'undefined' || this.UserId === "undefined")
    this.UserId = null;
  else
    this.UserId = parseInt(this.UserId);

  let params = new HttpParams().append(
    'FolderId', folderId,
  ).append(
    'name', folderName,
  )
    ;
  return this.http.get<{ Error: string, data: any }>
    (this.baseUrl + '/Folder/CheckFolderNameExists', { params: params })

}

ActivateFolderForRestoring(folderId, folderName) {
  this.authService.itemValue.subscribe((nextValue) => {
    this.UserId = nextValue.UserId;

  })
  if (!this.UserId || typeof this.UserId === 'undefined' || this.UserId === "undefined")
    this.UserId = null;
  else
    this.UserId = parseInt(this.UserId);

  let params = new HttpParams().append(
    'FolderId', folderId,
  ).append(
    'name', folderName,
  ).append('userID',this.UserId);
    ;
  this.http.get<{ Error: string, Status: string, Message: string }>
    (this.baseUrl + '/Folder/ActivateFolderForRestoring', { params: params }).subscribe(data => {
      this.getNavList();
    })

}


checkRestoreFolderFilesNameExists(data: Array<any>) {
  this.authService.itemValue.subscribe((nextValue) => {
    this.UserId = nextValue.UserId;

  })
  if (!this.UserId || typeof this.UserId === 'undefined' || this.UserId === "undefined")
    this.UserId = null;
  else
    this.UserId = parseInt(this.UserId);

  return this.http.post<{ Error: string, data: any }>
    (this.baseUrl + '/Folder/VerifyRestoreFiles', data)

}
getSearchResults(searchText:string)
  {
    this.authService.itemValue.subscribe((nextValue) => {
      this.UserId = nextValue.UserId;

    })
    if (!this.UserId || typeof this.UserId === 'undefined' || this.UserId === "undefined")
      this.UserId = null;
    else
      this.UserId = parseInt(this.UserId);

    let params = new HttpParams().append(
      'blobSearchInput', searchText,
    ).append('userID',this.UserId?this.UserId:0);
      ;
   return this.http.get<{ Error: string, data:any }>
      (this.baseUrl + "/Search/SearchAllDocuments", { params: params });
 }
  deleteNavItem(item: NavList) {
    this.authService.itemValue.subscribe((nextValue) => {
      this.UserId = nextValue.UserId;
    })
    if (!this.UserId || typeof this.UserId === 'undefined' || this.UserId === "undefined")
      this.UserId = null;
    else
      this.UserId = parseInt(this.UserId);

    let params = new HttpParams().append(
      'folderid', item.id
    ).append(
      'userId', this.UserId
    ).append('articleId',item.articleID?item.articleID:null).append('navitemType',item.type);
    this.http.delete<{ Error: string, Status: string, Message: string }>
      (this.baseUrl + "/Folder/DeleteFolder", { params: params })
      .subscribe((result) => {
        if(result.Status=="Failure"){
          this.setNotification("Something went wrong! Please try again after some time.", "Error");
          this.router.navigateByUrl('/home');
          return;
        }
        this.setNotification("Folder/File deleted Successfully!", "Success")
        if(item.type=="File")
          this.modifyLocalStatus(item.articleID,this.Deleted);
        else if(item.type=="Folder"){
          for(let i=0;i<item.children.length;i++){
            this.modifyLocalStatus(item.children[i].articleID,this.Deleted);
          }
        }
        this.getNavList();
      })
    this.router.navigateByUrl('/home');

  }

  getNavList() {
    this.authService.itemValue.subscribe((nextValue) => {
      this.UserId = nextValue.UserId;

    })
    if (!this.UserId || typeof this.UserId === 'undefined' || this.UserId === "undefined")
      this.UserId = null;
    else
      this.UserId = parseInt(this.UserId);

    let params = new HttpParams().append(
      'userId', this.UserId
    );
    this.http.get<{ Error: String, data: any, Status: string }>
      (this.baseUrl + '/NavPath/GetNavigationPath', { params: params })
      .subscribe((result) => {
        if(result.Status=="Failure"){
          this.setNotification("Something went wrong! Please try again after some time.", "Error");
          this.router.navigateByUrl('/home');
          return;
        }
        this.navList = result.data.folderList;
        this.navListUpdated.next([...this.navList]);
      });
  }


  getWidgets() {
    // this.authService.itemValue.subscribe((nextValue) => {
    //   this.UserId = nextValue.UserId;

    // })
    if (!this.UserId || typeof this.UserId === 'undefined' || this.UserId === "undefined")
      this.UserId = null;
    else
      this.UserId = parseInt(this.UserId);

    let params = new HttpParams().append(
      'userId', this.UserId
    );
    this.http.get<{ Error: string, data: any, Status: string }>
      (this.baseUrl + '/dashboard/GetUserDashboard', { params: params })
      .subscribe((data) => {
        if(data.Status=="Failure"){
          this.setNotification("Something went wrong! Please try again after some time.", "Error");
          this.router.navigateByUrl('/home');
          return;
        }
        this.widgetUpdated.next(data.data);
      });
  }
  getDashboardTable(status: string) {
    this.authService.itemValue.subscribe((nextValue) => {
      this.UserId = nextValue.UserId;

    })
    if (!this.UserId || typeof this.UserId === 'undefined' || this.UserId === "undefined")
      this.UserId = null;
    else
      this.UserId = parseInt(this.UserId);

    let params = new HttpParams().append(
      'userId', this.UserId,
    ).append(
      'status', status,
    );
    ;
    return this.http.get<{ Error: string, data: any, Status: string }>
      (this.baseUrl + '/dashboard/GetUserArticles', { params: params })

  }

  getNavListUpdateListener() {
    return this.navListUpdated.asObservable(); //it returns an object to which it can listen since articlesUpdated is private and it can be accessed outside
  }
  getWidgetUpdateListener() {
    return this.widgetUpdated.asObservable(); //it returns an object to which it can listen since articlesUpdated is private and it can be accessed outside
  }

  fetchOneArticle(id: string) {
    this.authService.itemValue.subscribe((nextValue) => {
      this.UserId = nextValue.UserId;

    })
    if (!this.UserId || typeof this.UserId === 'undefined' || this.UserId === "undefined")
      this.UserId = null;
    else
      this.UserId = parseInt(this.UserId);
    let params = new HttpParams().append(
      'userId', this.UserId,
    ).append(
      'articleId', id,
    );
    return this.http.get<{ Error: string, data: any, Status: string }>
      (this.baseUrl + '/Article/GetArticle/', { params: params });

  }

  fetchAttachment(attachmentId: number) {
    let params = new HttpParams().append(
      'attachmentId', attachmentId,
    );
    return this.http.get<{ Error: string, data: any, Status: string }>
      (this.baseUrl + '/Article/GetArticleAttachment/', { params: params });
  }

  fetchAttachmentStream(attachmentId: number) {
    let params = new HttpParams().append(
      'attachmentId', attachmentId,
    );    
    var result=this.http.get
    (this.baseUrl + '/Article/GetArticleAttachmentData/', { params: params ,responseType:'blob'})
    return result;
  }

  addArticles(title: string, content: string, attachmentUrl: string, AttachmentStatus:string, route: string, status: string, accesslevel: string, scheduledStartDate: any, scheduledEndDate: any, folderId: number, comments: string,autoSave:boolean) {
    // addArticles(title: string, content: string, attachmentUrl: string, route: string, status: string, accesslevel: string, scheduledStartDate: any, scheduledEndDate: any, folderId: number, comments: string) {
      this.authService.itemValue.subscribe((nextValue) => {
        this.UserId = nextValue.UserId;
        this.publisherName=nextValue.FirstName +" "+ nextValue.LastName;

      })
      if (!this.UserId || typeof this.UserId === 'undefined' || this.UserId === "undefined")
        this.UserId = null;
      else
        this.UserId = parseInt(this.UserId);
      //set Date in datetimeISO format before sending
      scheduledStartDate = moment(scheduledStartDate).format("YYYY-MM-DDT00:00:00.000") + "Z";
      scheduledEndDate = scheduledEndDate?moment(scheduledEndDate).format("YYYY-MM-DDT00:00:00.000") + "Z":null;
      let body = {
        Title: title,//string
        Content: content,//string
        // tags: JSON.stringify(tags), // stringified to string from array of strings
        Status: status, //string
        Accesslevel: accesslevel, //string
        ScheduledStartDate: scheduledStartDate, //datetime
        ScheduledEndDate: scheduledEndDate, //datetime
        FolderId: folderId,//int
        Userid: this.UserId, //int or  null
        Comments: comments,
        AutoSave:autoSave
      }
      this.http.post<{ Error: string, data: any, Status: string, Message: string }>
        (this.baseUrl + '/Article/CreateArticle', body)
        .subscribe(
          (result) => {
            if(result.Status=="Failure"){
              this.setNotification("Something went wrong! Article could not be created. Please try again after some time.", "Error");
              this.router.navigateByUrl('/home');
              return;
            }
            let articleId = result.data;
            this.localArticle[articleId]=body;
            this.localArticle[articleId].PublisherName= this.publisherName;
            console.log(this.localArticle[articleId]);
            if(AttachmentStatus==null){ //No attachments here
              this.getNavList();
              this.router.navigateByUrl('/home');
              let transferUrl = route.substring(0, route.lastIndexOf('/') + 1) + articleId;
              this.router.navigateByUrl(transferUrl);
              this.setNotification("Article created successfully!", "Success");
            }
            else{
                  let attachmentBody = {
                  ArticleId: parseInt(articleId),
                  // title: title,//string
                  AttachmentUrl: attachmentUrl,
                  AttachmentStatus: AttachmentStatus,
                  userid: this.UserId, //int or  null
                  }
                  this.http.post<{ Error: string, data: any, Status: string, Message: string }>
                  (this.baseUrl + '/Article/UploadAttachment', attachmentBody)
                  .subscribe(
                    (res) => {
                    if(res.Status=="Failure"){
                      this.setNotification("Something went wrong! Attachment could not be uploaded. Please try again after some time.", "Error");
                      this.router.navigateByUrl('/home');
                      return;
                    }
                    let attachmentID=res.data.AttachmentID;
                    this.localArticle[articleId].AttachmentId=[parseInt(attachmentID)];
                    this.localArticle[articleId].AttachmentUrl=attachmentUrl;
                    this.fetchAttachmentStream(attachmentID).subscribe(result=>{
                      if(result.size!=0){  
                        var blob = new Blob([result], { type: result.type });
                        var url = window.URL.createObjectURL(blob);
                        this.localArticle[articleId].AttachmentUrl=url;
                        this.getNavList();
                        this.router.navigateByUrl('/home');
                        let transferUrl = route.substring(0, route.lastIndexOf('/') + 1) + articleId;
                        this.router.navigateByUrl(transferUrl);
                        this.setNotification("Article created successfully!", "Success");
                      }
                      else{
                        this.setNotification("Something went wrong! Please try again in some time.","Error");
                        this.router.navigateByUrl('/home');
                        return;
                    }
                      
                    });
                   
                    }
                )
            }
          }
        );
    }

    updateArticles(id: string, title: string, content: string, attachmentUrl: string, AttachmentStatus:string,AttachmentID:number, route: string, status: string, accesslevel: string, scheduledStartDate: any, scheduledEndDate: any, folderId: number, comments: string,autoSave) {
      this.authService.itemValue.subscribe((nextValue) => {
        this.UserId = nextValue.UserId;

      })
      if (!this.UserId || typeof this.UserId === 'undefined' || this.UserId === "undefined")
        this.UserId = null;
      else
        this.UserId = parseInt(this.UserId);
      //set Date in datetimeISO format before sending
      scheduledStartDate = moment(scheduledStartDate).format("YYYY-MM-DDT00:00:00.000") + "Z";
      scheduledEndDate = scheduledEndDate?moment(scheduledEndDate).format("YYYY-MM-DDT00:00:00.000") + "Z":null;
      let body = {
        Id: parseInt(id),
        Title: title,//string
        Content: content,//string
        Attachment: attachmentUrl,//base64
        // tags: JSON.stringify(tags), // stringified to string from array of strings
        Status: status, //string
        Accesslevel: accesslevel, //string
        ScheduledStartDate: scheduledStartDate, //datetime
        ScheduledEndDate: scheduledEndDate, //datetime
        FolderId: folderId,//int
        Userid: this.UserId, //int
        Comments: comments,
        AutoSave: autoSave
      }
      this.http.post<{  Error: string, data: any, Status: string, Message: string }>
        (this.baseUrl + '/Article/CreateArticle', body)
        .subscribe(
              (result) => {
                if(result.Status=="Failure"){
                  this.setNotification("Something went wrong! Article could not be updated. Please try again after some time.", "Error");
                  this.router.navigateByUrl('/home');
                  return;
                }
                let articleId = id;
                this.localArticle[articleId].Title=title;
                this.localArticle[articleId].Status=status;
                this.localArticle[articleId].Accesslevel=accesslevel;
                this.localArticle[articleId].ScheduledStartDate=scheduledStartDate;
                this.localArticle[articleId].ScheduledEndDate=scheduledEndDate;
                this.localArticle[articleId].FolderId=folderId;
                this.localArticle[articleId].Userid=this.UserId;
                this.localArticle[articleId].Comments=comments;
                if(content)
                  this.localArticle[articleId].Content=content;
                if(AttachmentStatus==null){ //No attachment replaced/deleted
                  this.setNotification("Article updated successfully!", "Success");
                  let transferUrl;
                  if (route.includes('/edit/')) {
                    transferUrl = route.replace('edit/' + id, id)
                  }
                  else {
                    transferUrl = '/';
                    this.router.navigate(['/'])
                  }
                  this.router.navigateByUrl(transferUrl);
                }
                else{
                      let attachmentBody = {
                      Id:AttachmentID,
                      ArticleId: parseInt(articleId),
                      AttachmentUrl: attachmentUrl,
                      AttachmentStatus: AttachmentStatus,
                      Userid: this.UserId, //int or  null
                      }
                      this.http.post<{ Error: string, data: any, Status: string, Message: string }>
                      (this.baseUrl + '/Article/UploadAttachment', attachmentBody)
                      .subscribe(
                        (res) => {
                          if(res.Status=="Failure"){
                            this.setNotification("Something went wrong! Attachment could not be uploaded. Please try again after some time.", "Error");
                            this.router.navigateByUrl('/home');
                            return;
                          }
                        if(AttachmentStatus==this.AttchStatusDelete){
                          this.localArticle[articleId].AttachmentId=res.data.AttachmentID;
                          this.localArticle[articleId].AttachmentUrl=attachmentUrl;
                        }
                        else{
                          let attachmentID=res.data.AttachmentID;
                          this.localArticle[articleId].AttachmentId=[parseInt(attachmentID)];
                          this.localArticle[articleId].AttachmentUrl=attachmentUrl;
                        }
                        this.setNotification("Article updated successfully!", "Success");
                        let transferUrl;
                        if (route.includes('/edit/')) {
                          transferUrl = route.replace('edit/' + id, id)
                        }
                        else {
                          transferUrl = '/';
                          this.router.navigate(['/'])
                        }
                        this.router.navigateByUrl(transferUrl);
                        }
                    )
                }
                //Mandatory to call nav list after restoring the articles.
                 this.getNavList();
              }
            );
    }

  fetchFileContentReferencePath(fileName,articleId){
    let params = new HttpParams().append('fileName', fileName)
    .append('articleId', articleId)
    return this.http.get<{ Error: string, data: any, Status: string }>(this.baseUrl + '/Folder/GetFileContentReferencePath', { params: params });

  }
  updateFileContent(filePath,fileContent,articleId){
    let body = {
      fileContentReferencePath: filePath,
      fileContent: fileContent,
      articleId:articleId?articleId:0
    };
    return this.http.post<{ Error: string, data: any, Status: string, Message: string }>
    (this.baseUrl + '/Folder/UpdateFileContent', body);
  }

  fetchUserDetails() {
    let params = new HttpParams().append(
      'accessToken', localStorage.getItem('accessToken')
    )
    //API CALL


    return this.http.get<{ Error: string, data: any, Status: string }>(this.baseUrl + '/UserInformation/GetUserInformation', { params: params })
    .subscribe(
      (res) => {
        if(res.Status=="Failure"){
          this.setNotification("Login Unsuccessful! Please try again by visiting DLO Portal.","Error");
          this.router.navigateByUrl('/home');

        }
        else{
          let data = res.data;

          let abc = data.ArticleStatusCounts
          this.authService.setUserSession(data.UserId, data.FirstName, data.LastName, data.RoleName, data.EmailAddress);
            this.gettoken(localStorage.getItem('EmailAddress')).subscribe(data=>{
              if(data.authToken){
              this.authService.setAuthToken(data.authToken)
              if(data.authToken.roles.toLowerCase() === this.dloUser.toLowerCase()){
                this.router.navigateByUrl('/home');
              }
              else{ this.router.navigate(['/portal']);}

              }
              else{ this.setNotification("Login Unsuccessful! Please try again by visiting DLO Portal.","Error");
              this.router.navigateByUrl('/home');
            }
            });
        }
      }
    )
  }

  moveFiles(fName, fType, newFolderId, fileId) {
    this.authService.itemValue.subscribe((nextValue) => {
      this.UserId = nextValue.UserId;
    })
    if (!this.UserId || typeof this.UserId === 'undefined' || this.UserId === "undefined")
      this.UserId = null;
    else
      this.UserId = parseInt(this.UserId);
    let body = {
      id:parseInt(fileId),
      folderName: fName,
      parentId: parseInt(newFolderId),
      userId: this.UserId,
      folderType: fType
    };
    return this.http.post<{ Error: string, data: any, Status: string, Message: string }>
    (this.baseUrl + '/Folder/Save', body);
  }


  setNotification(msg, status) {

    this.notificationUpdated.next([{ msg: msg, status: status }])
  }
  getNotificationUpdateListener() {
    return this.notificationUpdated.asObservable();
  }
  gettoken(username){
    let body = {
      username :username,
      refreshToken : '',
      clientId :this.clientId,
      grantType : "create_token"
    };
    return this.http.post<any>
    (this.baseUrl + '/Token/Auth', body);
  }
  getRefreshToken():Observable<any>
  {
      let username = localStorage.getItem("EmailAddress")
      let refreshToken = localStorage.getItem("refreshToken")
      let clientId =this.clientId
      const grantType = "refresh_token";

      return this.http.post<any>(this.baseUrl+'/Token/Auth', {username, refreshToken,clientId,  grantType}).pipe(
       map(result => {
              if(result && result.authToken)
              {
                this.authService.setAuthToken(result.authToken)
              }

              return <any>result;

          })
          );

  }
  modifyLocalStatus(articleID,status){
    if( this.localArticle && this.localArticle[articleID]){
      this.localArticle[articleID].Status=status;
    }
  }
  sendChunk( chunk,chunkIndex,totalChunks,fileReference,extension,contentType ) {
    const formData = new FormData();
    formData.append('Chunk', chunk);
    formData.append('chunkIndex', chunkIndex);
    formData.append('totalChunks', totalChunks);
    formData.append('fileReference', fileReference);
    formData.append('extension', extension);
    formData.append('contentType', contentType);
    console.log(formData);
    return this.http.post<{ Error: string, data: any, Status: string, Message: string }>(this.baseUrl+'/ChunkUpload/ChunkUploadFile',formData);

  }
}
